module.exports = __webpack_public_path__ + "note-cn.40320b1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/template/Docks/ContactInfo/ContactNotes/images/note-cn.jpg
// module id = FuPC
// module chunks = 0